import { LoaderCircle } from 'lucide-react';

import useBreakpoint from '@/hooks/use-break-point';
import { cn } from '@/lib/utils';

const ReleaseFormLoading = () => {
  const isTablet = useBreakpoint('tablet');

  return (
    <div
      className={cn('flex items-center justify-center h-132.5', {
        'h-100': isTablet,
      })}
    >
      <LoaderCircle className="size-12 animate-spin text-primary" />
    </div>
  );
};
export default ReleaseFormLoading;
